import React, { useContext } from 'react'
import classNames from 'classnames'
import FullContent from 'modules/react/loan-calculator/layout/FullContent'
import CarHeaderWithText from 'modules/react/loan-calculator/content/CarHeaderWithText'
import Applicants from 'modules/react/loan-calculator/content/Applicants'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'
import Notice from 'modules/react/loan-calculator/content/Notice'

export default function Step2() {
  const {
    previousStep,
    applyNow,
    isLoadingApply,
    modalText,
    marketingIsChecked,
    setMarketingIsChecked
  } = useContext(LoanCalculatorContext)
  const buttonClassName = classNames('button default', { 'button--loading': isLoadingApply })

  const handleOnSubmit = (e) => {
    e.preventDefault()
    applyNow()
  }

  return (
    <>
      <FullContent>
        <CarHeaderWithText/>
        <form onSubmit={handleOnSubmit}>
          <Applicants/>
          <Notice>
            {modalText.consentText}
          </Notice>
          <div className='lc-footer'>
            <div className='lc-footer__left'>
              {modalText.consentTextMarketing && (
                <label className='lc-footer__checkbox'>
                  <input
                    type='checkbox'
                    checked={marketingIsChecked}
                    onChange={() => setMarketingIsChecked(!marketingIsChecked)}
                  />
                  <span>{modalText.consentTextMarketing}</span>
                </label>
              )}
            </div>
            <div className='lc-footer__right'>
              <button type='button' className='button outline' onClick={previousStep}>Tilbage</button>
              <button type='submit' className={buttonClassName}><span>Få tilbud</span></button>
            </div>
          </div>
        </form>
      </FullContent>
    </>
  )
}
